/* eslint-disable jira/filename-case */
// error types
export const QUERY_ERROR = 'QueryError' as const;
export const UNSUPPORTED_FIELD = 'JiraIssueFieldUnsupportedErrorExtension' as const;

// itsm practices
export const SERVICE_REQUEST = 'SERVICE_REQUEST' as const;
export const INCIDENT_MANAGEMENT = 'INCIDENT_MANAGEMENT' as const;
export const PROBLEM_MANAGEMENT = 'PROBLEM_MANAGEMENT' as const;
export const CHANGE_MANAGEMENT = 'CHANGE_MANAGEMENT' as const;
export const POST_INCIDENT_REVIEW = 'POST_INCIDENT_REVIEW' as const;

// cs practice
export const DEVELOPER_ESCALATION = 'DEVELOPER_ESCALATION' as const;

// case management practice
export const CASE_MANAGEMENT = 'CASE_MANAGEMENT' as const;

// fallback to REQUEST_TYPE if practices are not specified
export const REQUEST_TYPE = 'REQUEST_TYPE' as const;
export const ISSUE_TYPE = 'ISSUE_TYPE' as const;
export const UNASSIGNED_REQUEST_TYPE = 'UNASSIGNED_REQUEST_TYPE' as const;
